<template>
  <default-model v-show="visible" :title="useType == 1?'应用到安全组':'应用到网吧'" :confirmText="confirmText" @confirmFn="confirmFn" @closeFn="closeFn">
    <div class="modal-body ">
      <Form :label-width="70">
        <FormItem label="已选择:">
          <span class="fw"> {{selectVal.length}}条任务</span>
        </FormItem>
        <FormItem label="选择安全组:" v-if="useType ==1">
          <p><span>已选中<b class="mainCol f14">{{ disabledGroup.length }}</b>个安全组</span></p>
          <Checkbox-group v-model="disabledGroup">
            <Checkbox label="1">分组1</Checkbox>
            <Checkbox label="2">分组2</Checkbox>
            <Checkbox label="3">分组3</Checkbox>
          </Checkbox-group>
        </FormItem>
        <FormItem label="选择网吧:" v-else>
          <!-- <p>
            <span>已选中<b class="mainCol f14">{{ selectedNodes.length }}</b>个网吧</span>
            <Input class="fr" v-model="barInfo" style="width:200px;" placeholder="请输入网吧名称">
              <Button slot="append" icon="ios-search" @click="searchFn" v-on:keyup.enter="searchFn"></Button>
            </Input>

          </p> -->
          <Row :gutter="6">
            <Col span="10">
                <Card>
                    <p slot="title" class="f14 fw">网吧列表</p>
                    <p >
                      <Input class="fr" v-model="barInfo"  placeholder="请输入网吧名称或网吧ID">
                        <Button slot="append" icon="ios-search" @click="searchFn" v-on:keyup.enter="searchFn"></Button>
                      </Input>
                    </p>
                    <p>
                      <Tree :data="baseNewData" style="width: 100%; max-height: 400px;" class="treeData" show-checkbox ref="treeData" @on-check-change="selecChange"></Tree>
                    </p>
                </Card>
            </Col>
            <Col span="14" style="height: 100%;">
              <Card >
                <p slot="title"  class="f14 fw">已选的网吧:<b>({{selectedNodes.length}})</b> <i class="fr cp" @click="selectedNodes = []">全部移除</i></p>
                <p v-if="selectedNodes.length == 0" class="tac">暂无数据！</p>
                <p v-else>
                  <Row :gutter="6">
                    <Col span="12" v-for="(item,index) in selectedNodes" :key="index">
                      <Tag class="tagCon" :title="getBarName(item)" closable type="border" @on-close="handleClose(index)" >{{ getBarName(item) }}</Tag>
                    </Col>
                  </Row>
                </p>
              </Card>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
  </default-model>
</template>
<script>
import DefaultModel from './defaultModel.vue'
import { getBarSecGroup, applyStrategy} from '@/requests/task'
import { getPageOfBar} from '@/requests/selfClient'
export default {
  props: ['selectVal', 'type'],
  data() {
    return {
      title: '应用到安全组',
      confirmText: '确定',
      visible: false,
      disabledGroup: [],
      baseData: [],
      baseNewData: [],
      useType: 1,
      selectedNodes: [],
      ids: [],
      curData: '',
      barInfo: ''
    }
  },
  components: {
    DefaultModel
  },
  watch: {
    'visible'() {
      if (this.visible) {
        this.selectedNodes = []
        if (this.curData != undefined && this.curData.barVoList != undefined && this.curData.barVoList != '' && this.curData.barVoList != null) {
          this.curData.barVoList.forEach(el => {
            let index = this.selectedNodes.findIndex(val => val == el.barId)
            if (index == -1) {
              this.selectedNodes.push(el.barId)
            }
          })
        }
        this.getBarSecGroup()
      }
    },
    'selectedNodes'() {
      this.getNewData()
    }
  },
  methods: {
    handleClose(index) {
      this.selectedNodes.splice(index, 1)
    },
    getBarName(barId) {
      let flag = ''
      this.baseData.forEach(el => {
        let index = el.children.findIndex(val => val.barId == barId)
        if (index != -1) {
          flag = el.children[index].title
        }
      })
      return flag
    },
    getNewData() {
      this.baseNewData = []
      this.baseData.forEach(el => {
        el.expand = false
        let json = {
          expand: false,
          title: el.title,
          secId: el.secId,
          children: []
        }
        let global = false
        if (this.barInfo == '') {
          el.children.forEach(item => {
            let index = this.selectedNodes.findIndex(val => val == item.barId)
            let child
            if (index != -1) {
              child = {
                title: item.title,
                barId: item.barId,
                checked: true,
              }
            } else {
              child = {
                title: item.title,
                barId: item.barId,
              }
            }
            json.children.push(child)
            global = true
          })
           if (global) {
            this.baseNewData.push(json)
          }
        }else{
          el.children.forEach(item =>{
            if (item.title.indexOf(this.barInfo) != -1) {
              let index = this.selectedNodes.findIndex(val => val == item.barId)
              if (index != -1) {
                json = {
                  title: item.title,
                  barId: item.barId,
                  checked: true,
                }
              }else {
                json = {
                  title: item.title,
                  barId: item.barId,
                }
              }
              console.log(item)
              let index2 = this.baseNewData.findIndex(val => val.barId == item.barId)
              if(index2 == -1) {
                this.baseNewData.push(json)
              }
            }
          })
        }
      })
    },
    searchFn() {
      this.getNewData()
    },
    async getBarSecGroup() {
      let res = await getBarSecGroup()
      if (res.code == 200 && res.data != null) {
        let arr = []
        res.data.forEach((el, key) => {
          let json = ''
          if (key == 0) {
            json = {
              expand: false,
              title: el.secName,
              secId: el.secId,
              children: []
            }
          } else {
            json = {
              expand: false,
              title: el.secName,
              secId: el.secId,
              children: []
            }
          }
          if (el.barBaseVoList && el.barBaseVoList.length) {
            el.barBaseVoList.forEach(item => {
              let index = -1
              if (this.selectedNodes && this.selectedNodes) {
                index = this.selectedNodes.findIndex(val => val == item.barId)
              }
              let children = ''
              if (index != -1) {
                children = {
                  title: item.barName,
                  barId: item.barId,
                  checked: true,
                }
              } else {
                children = {
                  title: item.barName,
                  barId: item.barId,
                }
              }
              json.children.push(children)
            })
          }
          arr.push(json)
        })
        this.baseData = arr
        this.getNewData()
      }
    },
    selecChange(val) {
      console.log(this.baseNewData)
      // this.selectedNodes.forEach(val =>{
      //   let index
      // })
      this.baseNewData.forEach(item => {
        if (item.secId == undefined) {
          let index = this.selectedNodes.findIndex(list => list == item.barId)
          if (index != -1) {
            if (!item.checked) {
              this.selectedNodes.splice(index, 1)
            }
          }
        } else if (item.children && item.children.length) {
          item.children.forEach(obj => {
            let index = this.selectedNodes.findIndex(list => list == obj.barId)
            if (index != -1) {
              if (!item.checked) {
                this.selectedNodes.splice(index, 1)
              }
            }
          })
        }
      })
      if (val == '') {
        // this.selectedNodes = []
      } else {
        val.forEach(element => {
          if (element.secId == undefined && element.secId != '') {
            if (element.barId && element.barId != '') {
              let index = this.selectedNodes.findIndex(list => list == element.barId)
              if (index == -1) {
                this.selectedNodes.push(element.barId)
              }
            }
          }
        })
      }
    },
    async confirmFn() {
      // console.log(this.$refs.treeData.getCheckedNodes())
      // console.log(this.disabledGroup)
      // if (this.disabledGroup.length == 0 && this.useType == 1) {
      //   this.$Message.error('请选择安全组')
      //   return
      // }
      // if (this.useType == 2 && this.$refs.treeData.getCheckedNodes().length == 0) {
      //   this.$Message.error('请选择网吧')
      //   return
      // }
      let res = await applyStrategy({
        ids: this.ids,
        barIds: this.selectedNodes
      })
      if (res.code == 200) {
        // let isFinish = false
        // this.selectedNodes.forEach((el, key) => {
        //   if (key == this.selectedNodes.length - 1) {
        //     isFinish = true
        //   }
        // })
        if (this.selectedNodes == '') {
          this.$emit('reshFn')
          this.visible = false
        } else {
          this.getbarStatus(this.selectedNodes)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    closeFn() {
      this.visible = false
    },
    getbarStatus(data, isFinish) {
      let open = []
      data.forEach(async (el, index) => {
        let data2 = {
          num: 1,
          size: 5,
          key: encodeURIComponent(JSON.stringify({'barId': el}))
        }
        let res = await getPageOfBar(data2)
        if (res.code == 200) {
          if (res.data.records.length > 0) {
            if (this.type == 2) {
              if (!res.data.records[0].exeSwitch) {
                let key = open.findIndex(val => val == res.data.records[0].barId)
                if (key == -1) {
                  open.push(res.data.records[0].barId)
                }
              }
            } else {
              if (!res.data.records[0].securitySwitch) {
                let key = open.findIndex(val => val == res.data.records[0].barId)
                if (key == -1) {
                  open.push(res.data.records[0].barId)
                }
              }
            }
          }
        }
        if (index == data.length - 1 && open.length > 0) {
          if (this.type == 2) {
            this.$Notice.warning({
              title: '开机通道开关未开启',
              desc: '网吧' + open.toString() + '的开机通道未开启，请前往网吧列表进行开启，开启才可生效！',
              duration: 0,
            });
          } else {
            this.$Notice.warning({
              title: '防护开关未开启',
              desc: '网吧' + open.toString() + '的防护开关未开启，请前往网吧列表进行开启，开启才可生效！',
              duration: 0,
            });
          }
        }
        if (index == data.length - 1) {
          this.visible = false
          this.$emit('reshFn')
        }
      })
    }
  }
}
</script>

<style lang="scss" >
.treeData{
  // .ivu-tree-children{
  //   width: 100%;
  //   ul{
  //     width: 100%;
  //     display: inline-block;
  //     li{
  //       width: 50%;
  //     }
  //   }
  // }
  // .ivu-tree-children{
  //   .ivu-tree-children{
  //     width: 33.33%;
  //     display: inline-block;
  //   }
  // }
  max-height:500px;
  overflow-y: auto;
}
.tagCon {
    padding-right:  21px !important;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
    width: 155px !important;
    box-sizing: border-box;
    position: relative;
    .ivu-icon {
      position: absolute !important;
      left: 118px !important;
      top: 4px !important;
    }
  }

</style>